import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export default function FAQView({ data }) {
  return (
    <div className="w-full max-w-2xl mx-auto" data-testid="embed-content-wrapper">
      <div className="mb-6">
        <h2 className="font-display text-2xl md:text-3xl font-semibold tracking-tight text-zinc-950">
          {data?.title || "Untitled"}
        </h2>
        {data?.description ? (
          <p className="text-sm text-zinc-500 mt-1.5">{data.description}</p>
        ) : null}
      </div>

      <Accordion type="single" collapsible className="w-full border-t border-zinc-200">
        {(data?.items || []).map((q, i) => (
          <AccordionItem
            key={i}
            value={`item-${i}`}
            data-testid="embed-faq-item"
            className="border-b border-zinc-200"
          >
            <AccordionTrigger className="text-left font-medium text-zinc-950 hover:no-underline py-5">
              {q.question || "Untitled question"}
            </AccordionTrigger>
            <AccordionContent className="text-zinc-600 leading-relaxed pb-5">
              {q.answer}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
}
